export default "__VITE_ASSET__BgeNwUlI__"